import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getGatewayConfigs, getGatewayConfigRaw, publishGatewayConfig, createGatewayConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getGatewayConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_GATEWAY_CONFIGS_REQUEST);
    try {
      const response = yield call(getGatewayConfigs, partner);
      yield put(actions.getGatewayConfigsSuccess(response.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getGatewayConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getGatewayConfigRawWatcher() {
  while (true) {
    const { payload: { partner, id } } = yield take(types.GET_GATEWAY_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getGatewayConfigRaw, partner, id);
      yield put(actions.getGatewayConfigRawSuccess(response.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getGatewayConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishGatewayConfigWatcher() {
  while (true) {
    const { payload: { partner, id, rawYaml } } = yield take(types.PUBLISH_GATEWAY_CONFIG_REQUEST);
    try {
      const response = yield call(publishGatewayConfig, partner, id, rawYaml);
      yield put(actions.publishGatewayConfigSuccess(response.data));
      yield put(actions.getGatewayConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishGatewayConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createGatewayConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_GATEWAY_CONFIG_REQUEST);
    try {
      const response = yield call(createGatewayConfig, partner, rawYaml);
      yield put(actions.createGatewayConfigSuccess(response.data));
      yield put(actions.getGatewayConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createGatewayConfigFail(e.response ? e.response.data : {}));
    }
  }
}
